import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

/**
 * Falha de configuração vira um valor, não uma exceção.
 *
 * Com `createClient(undefined, undefined)` o supabase-js estoura durante o
 * *import*. Como imports são avaliados antes do corpo do módulo, nem um
 * try/catch no `index.js` pegaria: o grafo inteiro falha, o React nunca monta,
 * e o usuário vê tela branca sem nenhuma pista.
 *
 * Foi exatamente o que aconteceu com o primeiro instalador. Exportando o erro
 * em vez de lançá-lo, o `index.js` consegue mostrar uma tela que explica.
 */
export const configError = (() => {
  if (!supabaseUrl || !supabaseKey) {
    return 'O aplicativo foi gerado sem as credenciais do servidor '
      + '(REACT_APP_SUPABASE_URL e REACT_APP_SUPABASE_ANON_KEY).';
  }
  return null;
})();

// Com configuração ausente o cliente aponta para um destino inválido em vez de
// estourar. Nada chega a usá-lo: o `index.js` para antes, na tela de erro.
export const supabase = createClient(
  supabaseUrl || 'https://configuracao-ausente.invalid',
  supabaseKey || 'sem-chave',
)
